import { render, staticRenderFns } from "./ColumnLayout.vue?vue&type=template&id=6ff75fe4&"
import script from "./ColumnLayout.vue?vue&type=script&lang=tsx&"
export * from "./ColumnLayout.vue?vue&type=script&lang=tsx&"
import style0 from "./ColumnLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports